import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../css/modal.scss';

// import * as Hangul from 'hangul-js';

class KeyInputModal extends Component {
  current = 0;

  line1 = [
    ['`', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
    ['~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
    ['`', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '='],
    ['~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+'],
  ];
  line2 = [
    ['ㅂ', 'ㅈ', 'ㄷ', 'ㄱ', 'ㅅ', 'ㅛ', 'ㅕ', 'ㅑ', 'ㅐ', 'ㅔ', '[', ']'],
    ['ㅃ', 'ㅉ', 'ㄸ', 'ㄲ', 'ㅆ', 'ㅛ', 'ㅕ', 'ㅑ', 'ㅒ', 'ㅖ', '{', '}'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']'],
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', '{', '}'],
  ];
  line3 = [
    ['ㅁ', 'ㄴ', 'ㅇ', 'ㄹ', 'ㅎ', 'ㅗ', 'ㅓ', 'ㅏ', 'ㅣ', ';', "'"],
    ['ㅁ', 'ㄴ', 'ㅇ', 'ㄹ', 'ㅎ', 'ㅗ', 'ㅓ', 'ㅏ', 'ㅣ', ':', '"'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'"],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', ':', '"'],
  ];
  line4 = [
    ['ㅋ', 'ㅌ', 'ㅊ', 'ㅍ', 'ㅠ', 'ㅜ', 'ㅡ', ',', '.', '/'],
    ['ㅋ', 'ㅌ', 'ㅊ', 'ㅍ', 'ㅠ', 'ㅜ', 'ㅡ', '<', '>', '?'],
    ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M', '<', '>', '?'],
  ];

  constructor(props) {
    super(props);
    this.current =
      props.current === undefined || props.current > 4 ? 0 : props.current;
    this.state = {
      line1: this.line1[this.current],
      line2: this.line2[this.current],
      line3: this.line3[this.current],
      line4: this.line4[this.current],
    };
  }

  render() {
    const { isOpen, close } = this.props;
    const { line1, line2, line3, line4 } = this.state;
    return (
      <>
        {isOpen && this.props.posReducer.keyboardSetting ? (
          <>
            {/* big 1600 */}
            <div className="Modal-overlay-empty desk" onClick={close} />
            <div className="Modal-empty  desk">
              <div
                className="keyboard-container  desk"
                style={{ maxWidth: '1115px' }}>
                <div
                  className="keyboard-set  desk"
                  style={{ maxWidth: '1105px', color: '#fff' }}>
                  {line1.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic desk"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-back  desk"
                    onClick={() => this.props.backspace()}>
                    <div>Back</div>
                  </div>
                </div>
                <div
                  className="keyboard-set  desk"
                  style={{ maxWidth: '1105px', color: '#fff' }}>
                  <div
                    className="keyboard-main-enter  desk"
                    style={{ width: '100px' }}
                    onClick={() => this.props.keyin('층')}>
                    <div>층</div>
                  </div>
                  {line2.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic  desk"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-basic  desk"
                    style={{ width: '85px' }}
                    onClick={() => this.props.keyin('\\')}>
                    <div>\</div>
                  </div>
                </div>
                <div
                  className="keyboard-set  desk"
                  style={{ maxWidth: '1105px', color: '#fff' }}>
                  <div
                    className="keyboard-main-enter  desk"
                    style={{ width: '65px' }}
                    onClick={() => this.props.keyin('동')}>
                    <div>동</div>
                  </div>
                  <div
                    className="keyboard-main-enter  desk"
                    style={{ width: '65px' }}
                    onClick={() => this.props.keyin('호')}>
                    <div>호</div>
                  </div>
                  {line3.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic  desk"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-enter  desk"
                    onClick={() => this.props.ok()}>
                    <div>Enter</div>
                  </div>
                </div>
                <div
                  className="keyboard-set  desk"
                  style={{ maxWidth: '1105px', color: '#fff' }}>
                  <div
                    className="keyboard-main-enter  desk"
                    style={{ width: '100px' }}
                    onClick={() => this.props.keyin('번지')}>
                    <div>번지</div>
                  </div>
                  <div
                    className="keyboard-main-enter  desk"
                    style={{ width: '65px' }}
                    onClick={() => this.props.keyin('길')}>
                    <div>길</div>
                  </div>
                  {line4.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic  desk"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-shift  desk"
                    onClick={() => {
                      if (this.current % 2 === 0) this.current++;
                      else this.current--;
                      this.setState({
                        line1: this.line1[this.current],
                        line2: this.line2[this.current],
                        line3: this.line3[this.current],
                        line4: this.line4[this.current],
                      });
                    }}>
                    <div>Shift</div>
                  </div>
                </div>
                <div
                  className="keyboard-set  desk"
                  style={{ maxWidth: '1105px', color: '#fff' }}>
                  <div
                    className="keyboard-main-koreng  desk"
                    onClick={() => {
                      this.current = (this.current + 2) % 4;
                      this.setState({
                        line1: this.line1[this.current],
                        line2: this.line2[this.current],
                        line3: this.line3[this.current],
                        line4: this.line4[this.current],
                      });
                    }}>
                    <div>한/영</div>
                  </div>
                  <div
                    className="keyboard-main-space  desk"
                    onClick={() => this.props.keyin(' ')}>
                    <div>SPACE</div>
                  </div>
                </div>
              </div>
            </div>

            {/* pos 1024 *768 */}
            <div className="Modal-overlay-empty pos" onClick={close} />
            <div className="Modal-empty  pos">
              <div
                className="keyboard-container pos"
                style={{ maxWidth: '517px' }}>
                <div
                  className="keyboard-set pos"
                  style={{ maxWidth: '510px', color: '#fff' }}>
                  {line1.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic pos"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-back pos"
                    onClick={() => this.props.backspace()}>
                    <div>Back</div>
                  </div>
                </div>
                <div className="keyboard-set pos" style={{ color: '#fff' }}>
                  <div
                    className="keyboard-main-enter pos"
                    style={{ width: '60px' }}
                    onClick={() => this.props.keyin('층')}>
                    <div>층</div>
                  </div>
                  {line2.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic pos"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-basic pos"
                    style={{ width: '35px' }}
                    onClick={() => this.props.keyin('\\')}>
                    <div>\</div>
                  </div>
                </div>
                <div
                  className="keyboard-set pos"
                  style={{ maxWidth: '', color: '#fff' }}>
                  <div
                    className="keyboard-main-enter pos"
                    style={{ width: '35px' }}
                    onClick={() => this.props.keyin('동')}>
                    <div>동</div>
                  </div>
                  <div
                    className="keyboard-main-enter pos"
                    style={{ width: '35px' }}
                    onClick={() => this.props.keyin('호')}>
                    <div>호</div>
                  </div>
                  {line3.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic pos"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-enter pos"
                    onClick={() => this.props.ok()}>
                    <div>Enter</div>
                  </div>
                </div>
                <div
                  className="keyboard-set pos"
                  style={{ maxWidth: '517px', color: '#fff' }}>
                  <div
                    className="keyboard-main-enter pos"
                    style={{ width: '63px' }}
                    onClick={() => this.props.keyin('번지')}>
                    <div>번지</div>
                  </div>
                  <div
                    className="keyboard-main-enter pos"
                    style={{ width: '35px' }}
                    onClick={() => this.props.keyin('길')}>
                    <div>길</div>
                  </div>
                  {line4.map((value, index) => (
                    <div
                      key={index}
                      className="keyboard-main-basic pos"
                      onClick={() => this.props.keyin(value)}>
                      <div>{value}</div>
                    </div>
                  ))}
                  <div
                    className="keyboard-main-shift pos"
                    onClick={() => {
                      if (this.current % 2 === 0) this.current++;
                      else this.current--;
                      this.setState({
                        line1: this.line1[this.current],
                        line2: this.line2[this.current],
                        line3: this.line3[this.current],
                        line4: this.line4[this.current],
                      });
                    }}>
                    <div>Shift</div>
                  </div>
                </div>
                <div
                  className="keyboard-set pos"
                  style={{ maxWidth: '', color: '#fff' }}>
                  <div
                    className="keyboard-main-koreng pos"
                    onClick={() => {
                      this.current = (this.current + 2) % 4;
                      this.setState({
                        line1: this.line1[this.current],
                        line2: this.line2[this.current],
                        line3: this.line3[this.current],
                        line4: this.line4[this.current],
                      });
                    }}>
                    <div>한/영</div>
                  </div>
                  <div
                    className="keyboard-main-space pos"
                    onClick={() => this.props.keyin(' ')}>
                    <div>SPACE</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { posReducer } = state;
  return { posReducer };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(KeyInputModal);
